export default "__VITE_ASSET__DAYZfVfJ__"